import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Link,
} from "@mui/material";
import React, { useState } from "react";
import CircleIcon from "@mui/icons-material/Circle";
import FooterMenuItem from "./footerMenuItem";
import { Language } from "@mui/icons-material";
import LanguageAndCurrency from "./languageAndCurrency";
import SignInResponsiveDialog from "../uiElements/dialog/signInResponsiveDialog";
import SignInScreen from "src/screens/outerScreens/signin/signInScreen";
import { useNavigate } from "react-router-dom";
import { nextLocalStorage } from "src/components/api/helper/apiHelper";

const Footer = () => {
  const [dense, setDense] = React.useState(false);
  const [isSocialSignedIn, setIsSocialSignedIn] = useState(
    nextLocalStorage()?.getItem("SignInUser") === "True",
  );
  const isLoggedIn = !!sessionStorage.getItem("Token") || isSocialSignedIn;
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const navigate = useNavigate();
  const handleDeleteDialogOpen = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleSignInSuccess = () => {
    setIsSocialSignedIn(true);
    handleDeleteDialogClose();
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#000000",
          borderRadius: {
            xs: "20px 20px 0px 0px",
            sm: "20px 20px 0px 0px",
            md: "20px",
          },
          //p: "50px 30px 30px 30px",
          p: {
            xs: "50px 30px 120px 30px",
            sm: "50px 30px 120px 30px",
            md: "50px 30px 30px 30px",
          },
          m: {
            xs: "50px 0 0 0px",
            sm: "50px 0 0 0px",
            md: "50px 30px 30px 30px",
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <Box
              sx={{
                display: { xs: "flex", md: "block" },
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <img src="../logo.png" alt="" />
            </Box>
            <Typography
              variant="h6"
              color="#ffffff"
              mt={2}
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                textTransform: "uppercase",
                margin: "40px 0 10px 0",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Follow us on
            </Typography>
            <Box
              sx={{
                display: { xs: "flex", md: "block" },
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <Box sx={{ display: "flex", gap: "8px", marginTop: "10px" }}>
                <Link
                  href="https://www.youtube.com/channel/UCoL4PVeYZGevMmQ4mYepuSQ"
                  sx={{ color: "#fff", textDecoration: "none" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="../social_icon/youtube_icon.svg"
                    alt=""
                    height={30}
                    width={30}
                  />
                </Link>
                <Link
                  href="https://api.whatsapp.com/send?phone=918856042557"
                  sx={{ color: "#fff", textDecoration: "none" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="../social_icon/whatsapp_icon.svg"
                    alt=""
                    height={30}
                    width={30}
                  />
                </Link>
                <Link
                  href="https://instagram.com/TheKnockoutCulture"
                  sx={{ color: "#fff", textDecoration: "none" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="../social_icon/instagram_icon.svg"
                    alt=""
                    height={30}
                    width={30}
                  />
                </Link>
                <Link
                  href=""
                  sx={{ color: "#fff", textDecoration: "none" }}
                  // target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="../social_icon/linkedin_icon.svg"
                    alt=""
                    height={30}
                    width={30}
                  />
                </Link>
                <Link
                  href=""
                  sx={{ color: "#fff", textDecoration: "none" }}
                  // target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="../social_icon/facebook_icon.svg"
                    alt=""
                    height={30}
                    width={30}
                  />
                </Link>
                <Link
                  href=""
                  sx={{ color: "#fff", textDecoration: "none" }}
                  // target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="../social_icon/x_icon.svg"
                    alt=""
                    height={30}
                    width={30}
                  />
                </Link>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
            <Grid
              container
              spacing={2}
              sx={{
                mt: {
                  xs: 2,
                  sm: 2,
                  md: 0,
                },

                pt: {
                  xs: 2,
                  sm: 2,
                  md: 0,
                },

                borderBottom: {
                  xs: "2px solid transparent",
                  md: "none",
                },

                background: {
                  xs: `linear-gradient(
        to bottom,
        #000000 0px,
        #000000 1px,
        #26292e 1px,
        #26292e 2px
      ) top no-repeat`,
                  md: "none",
                },

                backgroundSize: {
                  xs: "100% 2px",
                  md: "auto",
                },

                backgroundClip: {
                  xs: "border-box",
                  md: "initial",
                },
              }}
            >
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <Box sx={{ color: "#ffffff" }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                    }}
                  >
                    Customer Service
                  </Typography>
                  <List dense={dense}>
                    <FooterMenuItem
                      link={isLoggedIn ? "/myAccount" : "#"}
                      listItemName="My Account"
                      onClick={(e) => {
                        if (!isLoggedIn) {
                          e.preventDefault();
                          handleDeleteDialogOpen();
                        }
                      }}
                    />
                    <FooterMenuItem
                      link="/TrackOrder"
                      listItemName="Track Your Order"
                    />
                    <FooterMenuItem
                      link="/ReturnPolicy"
                      listItemName="Returns"
                    />
                    <FooterMenuItem link="/Faqs" listItemName="FAQ's" />
                  </List>
                </Box>
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <Box sx={{ color: "#ffffff" }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                    }}
                  >
                    Company
                  </Typography>
                  <List dense={dense}>
                    <FooterMenuItem link="/AboutUs" listItemName="About Us" />
                    <FooterMenuItem link="/Blogs" listItemName="Blogs" />
                    <FooterMenuItem link="/Career" listItemName="Career" />
                    <FooterMenuItem
                      link="/ContactUs"
                      listItemName="Contact Us"
                    />
                  </List>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <Box sx={{ color: "#ffffff" }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                    }}
                  >
                    Our Information
                  </Typography>
                  <List dense={dense}>
                    <FooterMenuItem
                      link="/PrivacyPolicy"
                      listItemName="Privacy Policy"
                    />
                    <FooterMenuItem
                      link="/TermsAndConditions"
                      listItemName="Terms and Conditions"
                    />
                    <FooterMenuItem
                      link="/ReturnPolicy"
                      listItemName="Return Policy"
                    />
                    <FooterMenuItem
                      link="/ShippingPolicy"
                      listItemName="Shipping Policy"
                    />
                  </List>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
                <Box sx={{ color: "#ffffff" }}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                    }}
                  >
                    Contact
                  </Typography>
                  <Box sx={{ marginTop: "16px" }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 300,
                        mb: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img
                        src="../call_icon.svg"
                        width="18px"
                        height="18px"
                        alt="call"
                      />
                      <a
                        href="tel:+918856042557"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        +91 8856-04-2557
                      </a>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 300,
                        mb: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img
                        src="../mail_icon.svg"
                        width="18px"
                        height="18px"
                        alt="mail"
                      />
                      <a
                        href="mailto:support@theknockoutculture.com"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        support@theknockoutculture.com
                      </a>
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 300,
                        mb: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img src="../web_icon.svg" width="18px" height="18px" />{" "}
                      www.theknockoutculture.com
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                borderBottom: "2px solid transparent",
                background: `linear-gradient(to bottom, #000000 0px, #000000 1px, #26292e 1px, #26292e 2px) top no-repeat`,
                backgroundSize: "100% 2px",
                backgroundClip: "border-box",
                marginTop: "20px",
                paddingTop: "20px",
              }}
            >
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  xl={4}
                  sx={{ textAlign: { xs: "center" } }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                      color: "#ffffff",
                      marginBottom: "10px",
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    Download the App
                  </Typography>
                  <Box
                    sx={{
                      display: { xs: "flex", md: "block" },
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <img src="../playstore.png" alt="" width={"150px"} />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                      color: "#ffffff",
                      marginBottom: "10px",
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    100% Secure Payment
                  </Typography>
                  <Box
                    sx={{
                      display: { xs: "flex", md: "block" },
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <img src="../payment.png" alt="" width={"250px"} />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                      color: "#ffffff",
                      marginBottom: "10px",
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    Language/Currency
                  </Typography>
                  <Box
                    sx={{
                      display: { xs: "flex", md: "block" },
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <LanguageAndCurrency />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box
              sx={{
                borderBottom: "2px solid transparent",
                background: `linear-gradient(to bottom, #000000 0px, #000000 1px, #26292e 1px, #26292e 2px) top no-repeat`,
                backgroundSize: "100% 2px",
                backgroundClip: "border-box",
                paddingBottom: "6px",
                marginTop: "20px",
                paddingTop: "20px",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{ color: "#ffffff", fontSize: "14px", fontWeight: 300 }}
              >
                Copyright © 2026 TheKnockoutCulture.com
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <SignInResponsiveDialog
        open={isDeleteDialogOpen}
        handleClose={handleDeleteDialogClose}
      >
        <>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              order={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
            >
              <img
                src="/login_img.jpg"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              order={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }}
            >
              <SignInScreen onSignInSuccess={handleSignInSuccess} />
            </Grid>
          </Grid>
        </>
      </SignInResponsiveDialog>
    </>
  );
};

export default Footer;
